(() => {
  const instances = new Map();
  const buyBars = new Map();
  const linkObservers = new Map();

  function informationLink(element, className) {
    const link = document.createElement('a');
    link.href = 'https://www.stitch.me/pay-later';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.className = className;
    link.setAttribute('aria-label', element.dataset.scubaStitchLinkLabel);
    return link;
  }

  function linkWidget(element) {
    const logo = element.querySelector('.stitch-bnpl-widget__logo');
    if (logo && !logo.closest('.scuba-stitch-logo-link')) {
      const link = informationLink(element, 'scuba-stitch-logo-link');
      logo.replaceWith(link);
      link.append(logo);
    }

    const body = element.querySelector('.stitch-bnpl-widget__body');
    if (!body || body.querySelector('.scuba-stitch-text-link')) return;
    const wording = body.textContent;
    const brand = 'Stitch Pay Later';
    const position = wording.lastIndexOf(brand);
    if (position < 0) return;
    const link = informationLink(element, 'scuba-stitch-text-link');
    link.textContent = brand;
    body.replaceChildren(
      document.createTextNode(wording.slice(0, position)),
      link,
      document.createTextNode(wording.slice(position + brand.length))
    );
  }

  function sync() {
    if (!window.StitchBNPL) return;

    for (const [element, instance] of instances) {
      if (!element.isConnected) {
        linkObservers.get(element)?.disconnect();
        linkObservers.delete(element);
        instance.destroy();
        instances.delete(element);
      }
    }

    for (const [bar, observer] of buyBars) {
      if (!bar.isConnected) {
        observer.disconnect();
        buyBars.delete(bar);
      }
    }

    document.querySelectorAll('[data-scuba-stitch-mobile-buy]').forEach((bar) => {
      if (buyBars.has(bar)) return;
      const original = document.getElementById(bar.dataset.formId)?.querySelector('button[name="add"]');
      if (!original) return;
      const observer = new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting;
      });
      observer.observe(original);
      buyBars.set(bar, observer);
    });

    document.querySelectorAll('[data-scuba-stitch-price], [data-scuba-stitch-cart-price-selector]').forEach((element) => {
      const priceSelector = element.dataset.scubaStitchCartPriceSelector;
      const price = priceSelector ? null : Number(element.dataset.scubaStitchPrice);
      if ((!priceSelector && !Number.isFinite(price)) || instances.has(element)) return;

      const observer = new MutationObserver(() => linkWidget(element));
      observer.observe(element, { childList: true, subtree: true });
      linkObservers.set(element, observer);

      instances.set(element, window.StitchBNPL.createWidget({
        mountSelector: `#${CSS.escape(element.id)}`,
        price,
        priceSelector,
        minimumAmount: 100,
        logoBg: 'purple',
        width: '100%',
        locale: 'en-ZA',
        currency: 'ZAR'
      }));
      linkWidget(element);
    });
  }

  document.addEventListener('on:variant:change', sync);
  document.addEventListener('variant:change', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', sync);
  function start() {
    const selector = '[data-scuba-stitch-price], [data-scuba-stitch-cart-price-selector]';
    const observer = new MutationObserver((records) => {
      const replacedMount = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector))
      ));
      if (replacedMount) sync();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
